// extracted by mini-css-extract-plugin
export var cardIcon = "_ay-4";
export var checkboxCard = "_ay-0";
export var checkboxCardSelected = "_ay-3";
export var disabled = "_ay-1";
export var outerBorder = "_ay-2";
export var spacerMedium = "_ay-7";
export var spacerSmall = "_ay-6";
export var spacerXsmall = "_ay-5";